/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Work_0_DescInputs */

const en_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From idea to a live engagement app with auth and real-time leaderboards, launched to production.`)
};

const ar_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`من الفكرة إلى تطبيق تفاعلي مباشر مع مصادقة ولوحات فورية، أُطلق في الإنتاج.`)
};

const bn_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আইডিয়া থেকে অথ আর রিয়েল-টাইম লিডারবোর্ডসহ লাইভ এনগেজমেন্ট অ্যাপ, প্রোডাকশনে লঞ্চ করা।`)
};

const de_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der Idee zur live Engagement-App mit Auth und Echtzeit-Bestenlisten, in Produktion gelauncht.`)
};

const es_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De la idea a una app de participación en vivo con autenticación y rankings en tiempo real, lanzada a producción.`)
};

const fr_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De l'idée à une app d'engagement en direct avec authentification et classements temps réel, lancée en production.`)
};

const pt_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Da ideia a uma app de participação ao vivo com autenticação e tabelas em tempo real, lançada em produção.`)
};

const zh_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从想法到带登录和实时榜单的互动应用，直接上线生产环境。`)
};

const tr_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fikirden kimlik doğrulamalı, gerçek zamanlı liderlik tablolu canlı etkileşim uygulamasına, üretime çıkarılmış.`)
};

const ru_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`От идеи до живого engagement-приложения с авторизацией и реалтайм-лидербордами, запущенного в прод.`)
};

const pl_svc_mvp_sprint_work_0_desc = /** @type {(inputs: Svc_Mvp_Sprint_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Od pomysłu do żywej apki zaangażowania z logowaniem i rankingami w czasie rzeczywistym, wypuszczonej na produkcję.`)
};

/**
* | output |
* | --- |
* | "From idea to a live engagement app with auth and real-time leaderboards, launched to production." |
*
* @param {Svc_Mvp_Sprint_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_work_0_desc = /** @type {((inputs?: Svc_Mvp_Sprint_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "de") return de_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "es") return es_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_work_0_desc(inputs)
	return en_svc_mvp_sprint_work_0_desc(inputs)
});
export { svc_mvp_sprint_work_0_desc as "svc_mvp-sprint_work_0_desc" }